import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";

import { Api } from './api';

@Injectable()
export class EnumService {
  private endpoint: string = 'enums';

  constructor(private api: Api) {
  }

  public getEnums(): Observable<any> {
    return this.api.get(this.endpoint)
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/enum.service.ts